import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Button } from 'semantic-ui-react'
import {toggleModal} from "../../Actions/ToggleModal";
import {modifyEditID} from "../../Actions/ModifyEditID";

class WhitelistDomainsButton extends Component {
    openModal = e => {
        this.props.modifyEditID(this.props.pkID);
        this.props.toggleModal("whitelistDomainsModal")
    }

    render() {
        return (
            <div>
                <Button content="Whitelist Domains" basic color='blue' icon='shield alternate' onClick={this.openModal} fluid/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {
    toggleModal: toggleModal,
    modifyEditID: modifyEditID
}

export default connect(mapStateToProps, mapActionsToProps)(WhitelistDomainsButton)